import { bleLegendRange } from '../../constants/general';

const BLE_LEGEND_ITEMS = [
  { label: '≤1', color: '#f7fbff' },
  { label: '1-2', color: '#c6dbef' },
  { label: '2-3', color: '#6baed6' },
  { label: '3-5', color: '#2171b5' },
  { label: '>5', color: '#08306b' },
];

export const BLELegendDisplay = ({ config }) => {
  return (
    <div className="mb-4 w-40" key={Date.now()}>
      <span className="text-xs font-medium">{config.name}</span>
      {config.unit && <span className="text-xs font-medium"> ({config.unit})</span>}
      <div className="flex w-full overflow-hidden rounded">
        {BLE_LEGEND_ITEMS.map(item => (
          <div key={item.label} className="h-6 flex-1" style={{ backgroundColor: item.color }} />
        ))}
      </div>
      <div className="mt-1 flex w-full justify-between text-xs text-gray-600">
        {BLE_LEGEND_ITEMS.map(item => (
          <span key={item.label} className="flex-1 text-center text-[10px]">
            {item.label}
          </span>
        ))}
      </div>
    </div>
  );
};

export const WSELegendDisplay = ({ config, filterInfo, layerId }) => {
  const [min, max] = bleLegendRange(filterInfo.selectedCounty, layerId);

  const colors = {
    1: '#ffffff',
    2: '#4a98ca',
    3: '#08306b',
  };
  return (
    <div className="mb-4 w-40" key={Date.now()}>
      <span className="text-xs font-medium">{config.name}</span>
      {config.unit && <span className="text-xs font-medium"> ({config.unit})</span>}
      <div
        className="h-6 w-full rounded"
        style={{
          background: `linear-gradient(to right, 
              ${colors[1]} 0%, 
              ${colors[2]} 50%, 
              ${colors[3]} 100% `,
        }}
      />
      <div className="mt-1 flex w-full justify-between text-xs text-gray-600">
        <span>{min}</span>
        <span></span>
        <span></span>
        <span></span>
        <span>{max}</span>
      </div>
    </div>
  );
};

export const DamagePlainLegendDisplay = () => {
  return (
    <div className="mb-4 w-40" key={Date.now()}>
      <span className="text-xs font-medium">Damage Plain: Return Period</span>
      <div className="flex w-full overflow-hidden rounded">
        <div className="h-6 flex-1" style={{ backgroundColor: '#b6d6d8' }} />
        <div className="h-6 flex-1" style={{ backgroundColor: '#87bcbf' }} />
        <div className="h-6 flex-1" style={{ backgroundColor: '#6e8ca0' }} />
        <div className="h-6 flex-1" style={{ backgroundColor: '#324755' }} />
      </div>
      <div className="mt-1 flex w-full justify-between text-[10px] text-gray-600">
        <span className="text-center">{'>500 years'}</span>
        <span className="text-center">100-500 years</span>
        <span className="text-center">10-100 years</span>
        <span className="text-center">{'<10 years'}</span>
      </div>
    </div>
  );
};
